module.exports = __webpack_public_path__ + "static/media/Gallery-8.808a62d8.jpg";